import { IPDFTableHeader } from "src/Pages/components/PDF/TableHeader";
import { PDFTableHeader } from "src/Pages/components/PDF/TableHeader/PDFTableHeader";

interface IHeadReportProductionContract {
  typeDate: "VIGENCIA" | "ASSINATURA" | "EMISSAO" | "VENCIMENTO";
}

export const HeadReportProductionContract = ({ typeDate }: IHeadReportProductionContract) => {
  const dataHeaderPDF: IPDFTableHeader = [
    {
      style: {
        width: "22%",
        textAlign: "left",
        paddingLeft: "8px",
      },
      title: "Operadora",
    },
    {
      style: {
        width: "22%",
        textAlign: "left",
        paddingLeft: "8px",
      },
      title: "Contrato",
    },
    {
      style: {
        width: "30%",
        textAlign: "left",
      },
      title: "Titular/Razão",
    },
    {
      style: {
        width: "10%",
        textAlign: "left",
      },
      title: "CPF/CNPJ",
    },
    {
      style: {
        width: "10%",
        textAlign: "right",
      },
      title: typeDate === "ASSINATURA" ? "Data assinatura" : typeDate === "VIGENCIA" ? "Data vigência" : typeDate === "EMISSAO" ? "Data emissão" : "Data vencimento",
    },
    {
      style: {
        width: "10%",
        textAlign: "right",
      },
      title: "Mensalidade",
    },
    {
      style: {
        width: "8%",
        textAlign: "center",
      },
      title: "Vidas",
    },
  ];

  return <PDFTableHeader data={dataHeaderPDF} />;
};
